module.exports = __webpack_public_path__ + "static/media/arrow-down.f6308f39.svg";